import { z } from 'zod'

import { m } from '@maestro/commerce-blocks/schemas/helpers'

const phoneNumberRegex = /^(\+\d{1,3})?\d{8}$/

export const phoneNumberField = z
  .string()
  .nonempty(m('phone.required'))
  .regex(phoneNumberRegex, {
    message: m('phone.invalid'),
  })
